import React from "react";

type SelectInputCacheContextValue = {
  cacheUniq: number;
  incrementCacheUniq: () => void;
};

const SelectInputCacheContext =
  React.createContext<SelectInputCacheContextValue>({
    cacheUniq: 0,
    incrementCacheUniq: () => {},
  });

export const SelectInputCacheProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [cacheUniq, setCacheUniq] = React.useState(0);
  const incrementCacheUniq = React.useCallback(
    () => setCacheUniq((v) => v + 1),
    [],
  );
  return (
    <SelectInputCacheContext.Provider value={{ cacheUniq, incrementCacheUniq }}>
      {children}
    </SelectInputCacheContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useSelectInputCache = () =>
  React.useContext(SelectInputCacheContext);
